export default __webpack_public_path__ + "static/media/1782.ec40c153.png";